import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { IResultados } from "../../../interfaces/Resultados";
import { IPalabrasAgrovocWs } from "../../../interfaces/Workspace";
import { getResultDataFiltered } from "../../../api/resultados";
import { getPalabrasLogros } from "../../../api/palabrasLogros";
import Select from 'react-select'
import { ChartContainerLoader } from "../../../components/Generic/Charts";

const Logros: React.FC<{
  code?: string
}> = ({ code }) => {

  const { t, i18n } = useTranslation("translation", {
    keyPrefix: "logros",
  });

  const [logros, setLogros] = useState<IResultados[]>()

  const [listaPalabras, setListaPalabras] = useState<IPalabrasAgrovocWs[]>()
  const [palabra, setPalabra] = useState<IPalabrasAgrovocWs>()

  useEffect(() => {
    getResultDataFiltered({ paisId: code, idioma: i18n.language })
      .then((res) => {
        setLogros(res)
      })
    getPalabrasLogros({ paisId: code, idioma: i18n.language })
      .then((res) => {
        setListaPalabras(res)
      })

    return () => {
      setLogros(undefined)
      setListaPalabras(undefined)
      setPalabra(undefined)
    }
  }, [code, i18n.language])

  useEffect(() => {
    getResultDataFiltered({ paisId: code, palabraClave: palabra?.fK_Id_CodigoAgrovoc, idioma: i18n.language })
      .then((res) => {
        setLogros(res)
      })
  }, [palabra])

  if (!logros) {
    return <ChartContainerLoader colSize="12" />;
  }

  return (
    <div className="card" id="logros">
      <div className="card-body">
        <h5 className="card-title">{t("logros")} {new Date().getFullYear()-1}</h5>
        <div className="row">
          <div className="col-md-4 mb-3">
            <Select options={listaPalabras}
              value={palabra}
              onChange={(newValue) => { setPalabra(newValue!) }} placeholder={t("buscar_pc")}
              getOptionValue={(option) => `${option['fK_Id_CodigoAgrovoc']}`}
              getOptionLabel={(option) => `${option.termino}`}
              isClearable
            />
          </div>
        </div>
        <div className="row mb-2">
          <div className="col">
            <small>
              {t("encontraron")} <strong>{logros.length}</strong> {t("resultados")}
            </small>
          </div>
        </div>
        <ul className="overflow-y-auto overflow-x-hidden list-unstyled">
          {logros.map((logro, index) => (
            <li key={index} className="pb-4 pt-4 border-bottom">
              <div className="row align-items-center">
                <div className="col-12">
                  <div>
                    <small>{logro.nombrePais}</small>
                  </div>
                  <span className="text-iica-2 text-justify">
                    {logro.descripcion}
                  </span>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Logros;